var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
var StyledText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 1.3rem;\n  ", "\n"], ["\n  line-height: 1.3rem;\n  ", "\n"])), function (props) {
    switch (props.variant) {
        case "small":
            return "\n          font-size: ".concat(props.theme.fontSize.small, ",\n        ");
        default:
            return "";
    }
});
export default (function (props) {
    return _jsx(StyledText, __assign({ variant: props.variant }, { children: props.children }));
});
var templateObject_1;
//# sourceMappingURL=index.js.map